<rt-dialog-header [heading]="heading | translate"> </rt-dialog-header>

<rt-dialog-body layout-horizontal>
  <rt-box layout-horizontal>
    <div margin-right-small>
      <div class="icon-wrapper">
        <rt-icon name="work" size="small"></rt-icon>
      </div>
    </div>
    <div class="job-container" layout-vertical>
      <div class="job-description">
        <rt-heading [variant]="'heading large'">{{ title }}</rt-heading>
        @if (hasAnyDetails) {
          <div class="details" layout-horizontal layout-align-items-center>
            <ng-container *ngTemplateOutlet="departmentDetails"></ng-container>
            <ng-container *ngTemplateOutlet="locationsDetails"></ng-container>
            <ng-container *ngTemplateOutlet="workModelDetails"></ng-container>
            <ng-container *ngTemplateOutlet="priorityDetails"></ng-container>
          </div>
        }
      </div>
      <rt-divider margin-tb-small></rt-divider>
      <div layout-horizontal layout-align-items-center>
        <span text-weight-semi-bold margin-right-small-xx>
          {{ translations.publishedOn | translate }}:
        </span>
        @if (!isInternalJob) {
          <ng-container *ngTemplateOutlet="publishedOnCareersSite"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="publishedOnInternal"></ng-container>
        }
      </div>
    </div>
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  @if (isJobEditorContext) {
    <rt-button variant="plain" (click)="close()">
      {{ translations.keepEditing | translate }}
    </rt-button>
  }

  <rt-button variant="primary" (click)="onCtaButtonClick()">
    {{ ctaButtonLabelKey | translate }}
  </rt-button>
</rt-dialog-footer>

<ng-template #departmentDetails>
  @if (department) {
    <span
      #elRef
      [rtTooltip]="department"
      [rtTooltipEnabled]="isTruncatedFactory | fnCall: elRef"
      [class.max-width]="!!locationIds.length"
      class="department overflow-hidden"
      text-weight-semi-bold
    >
      {{ department }}
    </span>
  }
</ng-template>

<ng-template #locationsDetails>
  @if (locationIds.length) {
    @if (department) {
      <rt-divider variant="dot"> </rt-divider>
    }
    <span [class.locations]="locationIds.length > 1" class="overflow-hidden">
      <rt-assigned-locations-info-container
        [locationIds]="locationIds"
        [tooltipPosition]="'above'"
      ></rt-assigned-locations-info-container>
    </span>
  }
</ng-template>

<ng-template #workModelDetails>
  @if (hasWorkModel) {
    @if (department || locationIds.length) {
      <rt-divider variant="dot"></rt-divider>
    }
    @if (workModel.onSite) {
      <div class="work-model">
        <rt-icon name="domain" margin-right-small-xx></rt-icon>
        <span>{{ 'app.offer_form.work_model_section.on_site.title' | translate }}</span>
      </div>
    }
    @if (workModel.hybrid) {
      <div [attr.margin-left-small-x]="workModel.onSite || null" class="work-model">
        <rt-icon name="hybrid" margin-right-small-xx></rt-icon>
        <span>{{ 'app.offer_form.work_model_section.hybrid.title' | translate }}</span>
      </div>
    }
    @if (workModel.remote) {
      <div
        [attr.margin-left-small-x]="workModel.onSite || workModel.hybrid || null"
        class="work-model"
      >
        <rt-icon name="nav-careershub" margin-right-small-xx></rt-icon>
        <span>{{ 'app.offer_form.work_model_section.remote.title' | translate }}</span>
      </div>
    }
  }
</ng-template>

<ng-template #priorityDetails>
  @if (priorityOption) {
    @if (hasElementsBeforePriority) {
      <rt-divider variant="dot"></rt-divider>
    }
    <div class="priority" layout-horizontal layout-align-items-center>
      <rt-icon
        [name]="priorityOption.icon!"
        [colorToken]="priorityOption.iconColorToken || 'colorIconDefault'"
        margin-right-small-xx
      ></rt-icon>
      <span>{{ priorityOption.label }}</span>
    </div>
  }
</ng-template>

<ng-template #publishedOnCareersSite>
  <span> {{ translations.careersSite | translate }}</span>
  @if (publishedOnGoogleForJobs) {
    <rt-divider variant="dot"></rt-divider>
    <span>{{ translations.googleForJobs | translate }}</span>
  }
  @if (publishedOnIndeed) {
    <rt-divider variant="dot"></rt-divider>
    <span>{{ translations.indeed | translate }}</span>
  }
</ng-template>

<ng-template #publishedOnInternal>
  <span> {{ translations.internalUse | translate }}</span>
</ng-template>
